import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

function GatsbyHead(props: {
  author?: string;
  children?: any;
  description?: string;
  image?: string;
  keywords?: string;
  meta?: [];
  no_index?: boolean;
  og_description?: string;
  og_title?: string;
  og_image?: string;
  site_name?: string;
  title?: string;
  tw_description?: string;
  tw_image?: string;
  tw_title?: string;
  type?: string;
  siteUrl?: string;
}) {
  const data = useStaticQuery(detailsQuery);
  let metaContent = [
    {
      name: `description`,
      content: props.description || data.site.siteMetadata.description,
    },
    {
      property: `og:site_name`,
      content: props.site_name || 'DentalPost',
    },
    {
      property: `og:title`,
      content: props.og_title || props.title,
    },
    {
      property: `og:description`,
      content:
        props.og_description ||
        props.description ||
        data.site.siteMetadata.description,
    },
    {
      property: `og:type`,
      content: props.type || `website`,
    },
    {
      property: `og:url`,
      content: props.siteUrl,
    },
    {
      property: `twitter:title`,
      content: props.tw_title || props.title,
    },

    {
      property: `twitter:description`,
      content:
        props.tw_description ||
        props.description ||
        data.site.siteMetadata.description,
    },
    {
      property: `twitter:site`,
      content: `@DentalPost`,
    },
    {
      property: `apple-itunes-app`,
      content: `app-id=504971545`,
    },
  ];

  if (props.og_image || props.image) {
    metaContent.push({
      property: `og:image`,
      content: `https://www.dentalpost.net${props.og_image || props.image}`,
    });
  }

  if (props.tw_image || props.image) {
    metaContent.push({
      property: `twitter:card`,
      content: 'summary_large_image',
    });
    metaContent.push({
      property: `twitter:image`,
      content: `https://www.dentalpost.net${props.tw_image || props.image}`,
    });
  }

  if (!props.image && !props.og_image && !props.tw_image) {
    //defaut to logo when there is no main image for seo/social sharing
    metaContent.push({
      property: `og:image`,
      content: `https://www.dentalpost.net${data.file.publicURL}`,
    });
    metaContent.push({
      property: `twitter:card`,
      content: 'summary_large_image',
    });
    metaContent.push({
      property: `twitter:image`,
      content: `https://www.dentalpost.net${data.file.publicURL}`,
    });
    metaContent.push({
      property: `og:image:width`,
      content: `316px`,
    });
    metaContent.push({
      property: `og:image:height`,
      content: `200px`,
    });
  }

  if (props.no_index) {
    metaContent.push({
      property: `robots`,
      content: `noindex`,
    });
  }
  if (props.meta && props.meta.length > 0) {
    metaContent.concat(props.meta);
  }

  return (
    <>
      <html lang="en" />
      <title>{props.title || 'DentalPost'}</title>
      {metaContent.map((item) => {
        return (
          <meta
            key={!!item.name ? item.name : item.property}
            name={item.name}
            property={item.property}
            content={item.content}
          />
        );
      })}
      {props.children}
    </>
  );
}

export default GatsbyHead;

const detailsQuery = graphql`
  query DefaultSEOQuery {
    site {
      siteMetadata {
        title
        description
        author
        siteUrl
      }
    }
    file(relativePath: { eq: "dentalpost-logo-on-light-bg.png" }) {
      publicURL
    }
  }
`;
